Show Channel Definition
